import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

const STORAGE_KEY = "safelife_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, "rejected");
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 p-4 sm:p-6"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-navy text-white rounded-2xl shadow-soft-lg p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1">
          <p className="text-sm md:text-base font-semibold mb-1">
            <i className="fa-solid fa-cookie-bite text-lego mr-2" />
            Nós usamos cookies para melhorar sua experiência.
          </p>
          <p className="text-xs text-white/70 leading-relaxed">
            Ao continuar navegando, você concorda com nossa{" "}
            <Link to="/politica-privacidade" className="underline hover:text-lego">Política de Privacidade</Link>{" "}
            e{" "}
            <Link to="/cookies" className="underline hover:text-lego">Política de Cookies</Link>.
            Respeitamos a LGPD (Lei Geral de Proteção de Dados).
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button
            variant="ghost"
            onClick={reject}
            className="text-white/80 hover:bg-white/10 hover:text-white"
            data-testid="cookie-reject-btn"
          >
            Recusar
          </Button>
          <Button
            onClick={accept}
            className="bg-lego hover:bg-lego/90 text-white font-semibold"
            data-testid="cookie-accept-btn"
          >
            Aceitar cookies
          </Button>
        </div>
      </div>
    </div>
  );
}
